import React, { useEffect, useState } from 'react';
import { Flex, Input, Select, Button } from '@chakra-ui/react';
import { placingScoreTable } from './PlacingScoreTable';
import { Links } from '../page_calculator/components/links';

// 各スコアブロックの型
type ScoreInputState = {
  selectedData: 'A' | 'B' | 'C' | 'D';
  inputDec: string;
  inputPoints: string;
  grade: string;
  place: string;
  additionalNumber: string;
};

const initialScore: ScoreInputState = {
  selectedData: 'A',
  inputDec: '',
  inputPoints: '',
  grade: '',
  place: '',
  additionalNumber: '',
};

const LOCAL_STORAGE_KEY = 'RankingScore_5set';

export const RankingScoreAllEvent = () => {
  const [scores, setScores] = useState<ScoreInputState[]>(
    Array(5)
      .fill(null)
      .map(() => ({ ...initialScore }))
  );
  const [isInitialized, setIsInitialized] = useState(false);

  // 初期読み込み：localStorage から復元
  useEffect(() => {
    const stored = localStorage.getItem(LOCAL_STORAGE_KEY);
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        if (Array.isArray(parsed) && parsed.length === 5) {
          setScores(parsed);
        }
      } catch (e) {
        console.error('保存データの読み込みに失敗:', e);
      }
    }
    setIsInitialized(true);
  }, []);

  // 保存：scoresが変化したときに保存（初期化後のみ）
  useEffect(() => {
    if (!isInitialized) return;
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(scores));
  }, [scores, isInitialized]);

  // 入力更新関数
  const updateScore = (
    index: number,
    key: keyof ScoreInputState,
    value: string
  ) => {
    setScores((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [key]: value };
      return updated;
    });
  };

  // Placing Score 自動反映
  useEffect(() => {
    setScores((prev) =>
      prev.map((score) => {
        const ps = placingScoreTable[score.grade]?.[score.place];
        return ps !== undefined
          ? { ...score, additionalNumber: ps.toString() }
          : score;
      })
    );
  }, [scores.map((s) => s.grade + '_' + s.place).join('|')]);

  const totalRankingScore = Math.floor(
    scores.reduce(
      (sum, s) =>
        sum +
        parseInt(s.inputPoints || '0') +
        parseInt(s.additionalNumber || '0'),
      0
    ) / scores.length
  );

  // リセット関数（localStorageは残す）
  const resetInputs = () => {
    setScores(
      Array(5)
        .fill(null)
        .map(() => ({ ...initialScore }))
    );
  };

  return (
    <div style={{ padding: '16px' }}>
      <h1
        style={{ fontWeight: 'bold', fontSize: '24px', marginBottom: '12px' }}
      >
        RankingScore計算サイト <br />
        ⚠️実装中の為もう少々お待ちください⚠️
      </h1>
      <Button
        onClick={resetInputs}
        size="sm"
        style={{ marginTop: '12px', backgroundColor: '#ddd', color: '#333' }}
      >
        リセット
      </Button>
      {scores.map((score, index) => (
        <div
          key={index}
          style={{
            backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff',
            padding: '16px',
            marginBottom: '12px',
            borderRadius: '8px',
          }}
        >
          <h2>Score_{index + 1}</h2>
          <Select
            value={score.selectedData}
            onChange={(e) =>
              updateScore(
                index,
                'selectedData',
                e.target.value as 'A' | 'B' | 'C' | 'D'
              )
            }
            width="200px"
            marginBottom="8px"
            size="sm"
          >
            <option value="A">Decathlon</option>
            <option value="B">Heptathlon_Indoor</option>
            <option value="C">Heptathlon</option>
            <option value="D">Pentathlon_Indoor</option>
          </Select>

          <Input
            placeholder="Result (記録)"
            type="number"
            value={score.inputDec}
            onChange={(e) => updateScore(index, 'inputDec', e.target.value)}
            width="200px"
            marginBottom="8px"
          />

          <Input
            placeholder="Result Score"
            type="number"
            value={score.inputPoints}
            onChange={(e) => updateScore(index, 'inputPoints', e.target.value)}
            width="200px"
            marginBottom="8px"
          />

          <Flex marginBottom="8px">
            <Select
              placeholder="大会"
              value={score.grade}
              onChange={(e) => updateScore(index, 'grade', e.target.value)}
              width="100px"
              marginRight="8px"
              size="xs"
            >
              {Object.keys(placingScoreTable).map((grade) => (
                <option key={grade} value={grade}>
                  {grade}
                </option>
              ))}
            </Select>

            <Select
              placeholder="順位"
              value={score.place}
              onChange={(e) => updateScore(index, 'place', e.target.value)}
              width="100px"
              size="xs"
            >
              {Array.from({ length: 16 }, (_, i) => (
                <option key={i + 1} value={(i + 1).toString()}>
                  {i + 1}位
                </option>
              ))}
            </Select>
          </Flex>

          <Input
            placeholder="Placing Score"
            type="number"
            value={score.additionalNumber}
            onChange={(e) =>
              updateScore(index, 'additionalNumber', e.target.value)
            }
            width="200px"
          />

          <div style={{ marginTop: '8px' }}>
            <strong>Performance Score: </strong>
            {parseInt(score.inputPoints || '0') +
              parseInt(score.additionalNumber || '0')}
          </div>
        </div>
      ))}
      ここから横並びにしてみる
      {scores.map((score, index) => (
        <div
          key={index}
          style={{
            backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff',
            padding: '6px',
            borderRadius: '8px',
            width: '700px',
          }}
        >
          {' '}
          <Flex marginRight="1px" width="100%">
            <h2 style={{ marginTop: '8px', marginRight: '5px' }}>
              {index + 1}
            </h2>
            <Select
              value={score.selectedData}
              onChange={(e) =>
                updateScore(
                  index,
                  'selectedData',
                  e.target.value as 'A' | 'B' | 'C' | 'D'
                )
              }
              width="120px"
              marginTop="4px"
              size="sm"
            >
              <option value="A">Decathlon</option>
              <option value="B">Heptathlon_Indoor</option>
              <option value="C">Heptathlon</option>
              <option value="D">Pentathlon_Indoor</option>
            </Select>
            <Select
              placeholder="大会"
              value={score.grade}
              onChange={(e) => updateScore(index, 'grade', e.target.value)}
              width="80px"
              marginTop="4px"
              size="sm"
            >
              {Object.keys(placingScoreTable).map((grade) => (
                <option key={grade} value={grade}>
                  {grade}
                </option>
              ))}
            </Select>
            <Select
              placeholder="順位"
              value={score.place}
              onChange={(e) => updateScore(index, 'place', e.target.value)}
              width="80px"
              marginTop="4px"
              size="sm"
            >
              {Array.from({ length: 16 }, (_, i) => (
                <option key={i + 1} value={(i + 1).toString()}>
                  {i + 1}位
                </option>
              ))}
            </Select>{' '}
            <Input
              placeholder="Pl_Score"
              _placeholder={{ fontSize: '10px' }}
              type="number"
              value={score.additionalNumber}
              onChange={(e) =>
                updateScore(index, 'additionalNumber', e.target.value)
              }
              width="100px"
            />{' '}
            <Input
              placeholder="Result"
              _placeholder={{ fontSize: '10px', color: 'gray.400' }}
              type="number"
              value={score.inputDec}
              onChange={(e) => updateScore(index, 'inputDec', e.target.value)}
              width="100px"
            />
            <Input
              placeholder="Result Score"
              _placeholder={{ fontSize: '10px', color: 'gray.400' }}
              type="number"
              value={score.inputPoints}
              onChange={(e) =>
                updateScore(index, 'inputPoints', e.target.value)
              }
              width="100px"
            />
            <div style={{ marginTop: '8px', marginLeft: '10pt' }}>
              {parseInt(score.inputPoints || '0') +
                parseInt(score.additionalNumber || '0')}
            </div>{' '}
          </Flex>
        </div>
      ))}
      <div
        style={{
          backgroundColor: '#eee',
          padding: '12px',
          borderRadius: '6px',
        }}
      >
        <strong>Ranking Score（平均）:</strong> {totalRankingScore}
      </div>
      <Links />
    </div>
  );
};
